import EmailIntegrationDemo from "./EmailIntegrationDemo";
import EmailTestSuite from "./EmailTestSuite";


export default function Email() {
  return (
    <main className="container mx-auto py-8">
      <div className="text-center mb-8">
        <h1 className="text-4xl font-bold mb-4">Cross-Project Firebase Email Integration</h1>
        <p className="text-muted-foreground mb-2">
          Your main app
           {/* (nkurenkuru-36978) */}
            unicomms now uses email functions from nkurenkuru-town-council
        </p>
        <p className="text-sm text-muted-foreground">
          Main App: nkurenkuru-36978 | Email Functions: nkurenkuru-town-council (us-central1)
        </p>
      </div>

      <div className="mb-8">
        <EmailIntegrationDemo />
       
      </div>

      <EmailTestSuite />

      <div className="mt-12 max-w-4xl mx-auto">
        <h2 className="text-2xl font-semibold mb-4">Cross-Project Setup Complete</h2>
        <div className="grid md:grid-cols-2 gap-6">
          <div className="space-y-4">
            <h3 className="text-lg font-medium">✅ Integration Architecture:</h3>
            <ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground">
              <li>Main App: nkurenkuru-36978 (Firebase Auth, Firestore, Storage)</li>
              <li>Email Functions: nkurenkuru-town-council (Cloud Functions)</li>
              <li>Cross-project API calls via HTTPS endpoints</li>
              <li>Secure, scalable, and maintainable architecture</li>
            </ul>
          </div>

          <div className="space-y-4">
            <h3 className="text-lg font-medium">🚀 Available Email Functions:</h3>
            <ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground">
              <li>
                <code>sendMail</code> - Basic email sending
              </li>
              <li>
                <code>sendMailCC</code> - Email with CC recipients
              </li>
              <li>
                <code>sendScorecardEmail</code> - HTML emails with attachments
              </li>
              <li>
                <code>sendMailUpload</code> - Email with file attachments
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 p-4 bg-muted rounded-lg">
          <h3 className="text-lg font-medium mb-2">📝 Usage in Your App:</h3>
          <pre className="text-sm text-muted-foreground overflow-x-auto">
            {`import AppStore from "@/lib/stores/AppStore"

const appStore = new AppStore()
const response = await appStore.mailApi.sendMail(
  ["recipient@example.com"], 
  "sender@nkurenkuru-tc.com", 
  [], 
  "Subject", 
  "Message"
)`}
          </pre>
        </div>
      </div>
    </main>
  )
}
